import { render } from "./ManageSkill.vue?vue&type=template&id=e7d490de&scoped=true"
import script from "./ManageSkill.vue?vue&type=script&lang=js"
export * from "./ManageSkill.vue?vue&type=script&lang=js"

import "./ManageSkill.vue?vue&type=style&index=0&id=e7d490de&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7d490de"]])

export default __exports__